import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {LoadingPopupService} from "@app/presentation/services/loading/loading-popup.service";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
    ],
    providers: [
        LoadingPopupService,
    ]
})
export class LoadingServiceModule {

}
